import _ from 'underscore';

/**
 * Passes constant double curly brace settings to the underscore template function.
 * E.g. to support templates of the format: 'The bid is {{bidAmount}}'
 *
 * @see {@link http://underscorejs.org/#template}
 *
 * @param {String} templateString - The template markup that contains double curly bracket notation.
 * @return {Function} The template function, which can be passed an Object model with fields that
 *    correspond to the names marked up by the curly braces.
 */
export function curlyTemplate(templateString) {
  const settings = {
    escape: '',
    evaluate: '',
    interpolate: /\{\{(.+?)\}\}/g,
  };

  return _.template(templateString, settings);
}

/**
 * check whether this string include CJK charact
 * @param {string} str - string to check
 * @returns {boolean} - return true if str contains CJK, otherwise, return false
 */
export function hasCJK(str) {
  return !!(_.isString(str) && str.match(/[\u4E00-\u9FCC]/));
}



// WEBPACK FOOTER //
// ./d:/dbs/el/aapusc/private/client/packages/primitive-utilities/src/string.es